import { getImageUrl } from './getImageUrl'
import { normalizeImageName } from './normalizeImageName'

export function getProtocolImage(protocol: string) {
  if (protocol.toLowerCase() === 'fallback') {
    return getImageUrl('protocols', 'unknownProtocol')
  }
  return getImageUrl('protocols', normalizeImageName('protocols', protocol))
}
